import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-800">
            影片分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">按类型快速找到你想看的影片</p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-500/30 hover:bg-background-100 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}